import React from 'react';
import { setVisibleProjects } from '../../../../../actions/ui';
import { getProject, searchProject } from '../../../../../helpers/project-helper';
import { usePaginatedSearchList } from '../../../../../hooks/usePaginatedSearchList';
import {
    getProjectStatusSummary,
    mapProjectForList,
} from '../helpers';

export const useProjectListScreen = ({ token, dispatch }) => {
    const {
        items: projects,
        isLoading,
        error,
        pagination,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    } = usePaginatedSearchList({
        token,
        getItems: getProject,
        searchItems: searchProject,
        initialSearchField: 'code',
        initialStatusFilter: 'ALL',
        initialRowsPerPage: 10,
        debounceMs: 600,
    });

    const mappedProjects = React.useMemo(() => {
        return (Array.isArray(projects) ? projects : []).map((project) => mapProjectForList(project));
    }, [projects]);

    const statusSummary = React.useMemo(() => getProjectStatusSummary(mappedProjects), [mappedProjects]);

    React.useEffect(() => {
        dispatch(setVisibleProjects(mappedProjects));
    }, [dispatch, mappedProjects]);

    React.useEffect(() => {
        return () => {
            dispatch(setVisibleProjects([]));
        };
    }, [dispatch]);

    return {
        mappedProjects,
        isLoading,
        error,
        pagination,
        statusSummary,
        searchTerm,
        searchField,
        statusFilter,
        rowsPerPage,
        setOffset,
        handleRowsPerPageChange,
        handleSearchTermChange,
        handleSearchFieldChange,
        handleStatusFilterChange,
        handleClearFilters,
    };
};
